module.exports = __webpack_public_path__ + "static/mastiff-d7cefb14a163a9426d8ed2883363980b.jpeg";